var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 206 57.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea75ad;}.cls-2{fill:#5d3233;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.69,28.33s-30.62,29.18-68.38,29.18-71-26.91-71-26.91S65.24,0,103,0C138.64,0,172.69,28.33,172.69,28.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,19.38c0-.16.16-.26.29-.3A2.84,2.84,0,0,1,.71,19a6.06,6.06,0,0,1,.85,0c.56,0,1.12,0,1.68,0,1.11.07,2.21.16,3.32.26,2.2.23,4.38.47,6.56.74l13,1.63c8.63,1.07,17.2,2.1,25.77,2.94,17.13,1.75,34.21,2.85,51.28,3.13A506.77,506.77,0,0,0,154.38,26c8.55-.71,17.1-1.67,25.69-2.8,4.29-.55,8.59-1.18,12.91-1.81l13-2c-15.62,8.31-32.64,13.85-50,17.48a242.23,242.23,0,0,1-53,4.82,263.53,263.53,0,0,1-52.8-6.29,256.67,256.67,0,0,1-25.54-7.1c-4.19-1.41-8.33-2.91-12.42-4.53-2.05-.8-4.09-1.64-6.12-2.47-1-.42-2-.84-3-1.23-.51-.2-1-.39-1.54-.56-.25-.08-.51-.16-.77-.22a2.63,2.63,0,0,0-.39-.06C.19,19.22,0,19.23,0,19.38Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset42);
export default __webpack_public_path__ + "static/media/Asset 4 (2).304d384a.svg";
export { ForwardRef as ReactComponent };